export default {
    toastTimeout: 3000,
    trayPosition: 'bottom-right',
    toastMargin: '5',
    pauseOnHover: false
};


// WEBPACK FOOTER //
// ./src/ButterToast/defaults.js